// extracted by mini-css-extract-plugin
export default {"bg":"Footer_bg__PAwQh","logoContainer":"Footer_logoContainer__gcCtx","logo":"Footer_logo__-k9w0","Background":"Footer_Background__W7hHS"};